import useDevice from 'hooks/DesktopDevice.hook';
import Stack from 'styles/stack/Stack';
import Typography from 'styles/typography/Typograpy';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

type ContainerFooter = {
	ml?: string;
};

export const FooterDesktop: React.FC<ContainerFooter> = props => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const year = new Date().getFullYear();

	const { isDesktop } = useDevice();

	return (
		<Stack
			sx={{ borderTop: 1, ml: !!props.ml ? props.ml : 0, width: '100%' }}
			direction={'row'}
			height={isDesktop ? '70px' : '60px'}
			alignItems={'center'}
		>
			<Stack flexGrow={1}>
				<Typography variant="caption">{`© ${year} ${tClientLabels(
					'sharedLayout.footerRightReserved',
				)}`}</Typography>
			</Stack>
		</Stack>
	);
};
